import React, { useState, useEffect } from 'react';
import BOMList from './BOMList';
import ViewBOM from './ViewBOM';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './BOMs.css';

function BOMs({ initialViewMode, initialBOMId, initialProductId }) {
  const [selectedBOMId, setSelectedBOMId] = useState(initialBOMId || null);
  const [viewMode, setViewMode] = useState(initialViewMode || 'list'); // 'list', 'view', 'edit', 'create'
  const [preselectedProductId, setPreselectedProductId] = useState(initialProductId || null);

  useEffect(() => {
    // Set toolbar based on current mode
    if (window.setToolbar) {
      if (viewMode === 'list') {
        window.setToolbar({
          title: 'BOMs',
          buttons: [
            {
              label: 'New BOM',
              icon: '➕',
              onClick: handleNew,
              variant: 'primary'
            },
            {
              label: 'Refresh',
              icon: '🔄',
              onClick: handleRefresh
            }
          ]
        });
      } else if (viewMode === 'view') {
        window.setToolbar({
          title: 'View BOM',
          showBack: true,
          onBack: handleBack,
          buttons: [
            {
              label: 'Edit',
              icon: '✏️',
              onClick: handleEdit,
              variant: 'secondary'
            },
            {
              label: 'Duplicate',
              icon: '📋',
              onClick: handleDuplicate,
              variant: 'secondary'
            },
            {
              label: 'Delete',
              icon: '🗑️',
              onClick: handleDelete,
              variant: 'danger'
            }
          ]
        });
      } else if (viewMode === 'edit') {
        window.setToolbar({
          title: 'Edit BOM',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Save',
              icon: '💾',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      } else if (viewMode === 'create') {
        window.setToolbar({
          title: 'New BOM',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Create',
              icon: '➕',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      }
    }

    return () => {
      if (window.setToolbar) {
        window.setToolbar(null);
      }
    };
  }, [viewMode]);

  const handleSelectBOM = (bomId) => {
    setSelectedBOMId(bomId);
    setViewMode('view');
  };

  const handleNew = () => {
    setSelectedBOMId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleDuplicate = () => {
    if (window.viewBOMRef && window.viewBOMRef.handleDuplicate) {
      window.viewBOMRef.handleDuplicate();
    }
  };

  const handleDelete = () => {
    // Delete will be handled in ViewBOM component
    if (window.viewBOMRef && window.viewBOMRef.handleDelete) {
      window.viewBOMRef.handleDelete();
    }
  };

  const handleSave = () => {
    // Save will be handled in ViewBOM component
    if (window.viewBOMRef && window.viewBOMRef.handleSave) {
      window.viewBOMRef.handleSave();
    }
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedBOMId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedBOMId(null);
  };

  const handleRefresh = () => {
    // Trigger refresh in BOMList
    if (window.bomListRef && window.bomListRef.fetchBOMs) {
      window.bomListRef.fetchBOMs();
    }
  };

  const handleBOMSaved = (bom) => {
    setSelectedBOMId(bom.bom_id);
    setViewMode('view');
    // Refresh the list
    if (window.bomListRef && window.bomListRef.fetchBOMs) {
      window.bomListRef.fetchBOMs();
    }
  };

  const handleBOMCreated = (bomId) => {
    setSelectedBOMId(bomId);
    setViewMode('view');
    if (window.bomListRef && window.bomListRef.fetchBOMs) {
      window.bomListRef.fetchBOMs();
    }
  };

  return (
    <div className="boms-page">
      <ResizablePanels
        leftPanel={
          <BOMList
            ref={ref => window.bomListRef = ref}
            onSelectBOM={handleSelectBOM}
            selectedBOMId={selectedBOMId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewBOM
              ref={ref => window.viewBOMRef = ref}
              bomId={selectedBOMId}
              onBack={handleBack}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onSave={handleBOMSaved}
              onCancel={handleCancel}
              onEdit={handleEdit}
              onBOMCreated={handleBOMCreated}
              preselectedProductId={preselectedProductId}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
}

export default BOMs;